/** Sólo direcciones de Instagram; nunca HTML ni destinos elegidos por terceros. */
export function normalizeInstagramUrl(value: string) {
  let raw = value.trim();
  if (/^@[a-zA-Z0-9._]{1,30}$/.test(raw))
    raw = `https://www.instagram.com/${raw.slice(1)}/`;
  if (/^(www\.|m\.)?instagram\.com\//i.test(raw)) raw = `https://${raw}`;
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    throw new Error("Ingresá un perfil o enlace válido de Instagram.");
  }
  if (
    raw.length > 2048 ||
    url.protocol !== "https:" ||
    !["instagram.com", "www.instagram.com", "m.instagram.com"].includes(
      url.hostname,
    ) ||
    url.username ||
    url.password ||
    url.port ||
    url.pathname === "/" ||
    /[\\\s]/.test(raw)
  )
    throw new Error("Ingresá un enlace HTTPS de Instagram.");
  if (/^\/(accounts|oauth|direct|explore)(\/|$)/i.test(url.pathname))
    throw new Error("Usá el perfil o contenido público de la obra.");
  url.hostname = "www.instagram.com";
  url.hash = "";
  for (const key of [
    "igsh",
    "igshid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
  ])
    url.searchParams.delete(key);
  return url.toString();
}
export function instagramEmbedUrl(value: string) {
  try {
    const url = new URL(normalizeInstagramUrl(value));
    if (
      /^\/(p|reel|tv)\/[a-zA-Z0-9_-]+\/?$/.test(url.pathname) ||
      /^\/[a-zA-Z0-9._]{1,30}\/?$/.test(url.pathname)
    )
      return url.origin + url.pathname;
  } catch {}
  return null;
}
export function purchasePath(slug: string, functionId?: string) {
  return `/comprar/${encodeURIComponent(slug)}${functionId ? `?fecha=${encodeURIComponent(functionId)}` : ""}`;
}
